var _desc, _defs, _rect, _circle, _circle2, _rect2, _rect3, _circle3, _circle4, _circle5, _text, _text2, _text3, _text4, _text5, _text6, _text7, _text8, _rect4, _text9, _text10, _rect5, _text11, _rect6, _text12, _rect7, _text13, _rect8, _text14, _rect9, _ellipse, _rect10, _ellipse2, _text15, _text16, _path, _path2, _polygon, _polygon2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 360",
    role: "img",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Backend Development") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Professional backend setup with Spring Boot code editor, runtime logs, API routes, and database flow.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bg",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0f3553"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "65%",
    stopColor: "#08243a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#051828"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "panel",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#123d5c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#0d2e47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "line",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#79cbff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#ffd700"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 640,
    height: 360,
    rx: 18,
    fill: "url(#bg)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 552,
    cy: 54,
    r: 110,
    fill: "#6dc8ff",
    opacity: 0.06
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 92,
    cy: 328,
    r: 120,
    fill: "#ffd700",
    opacity: 0.05
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 42,
    width: 372,
    height: 278,
    rx: 14,
    fill: "url(#panel)",
    stroke: "#2a6e99",
    strokeWidth: 1.4
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 42,
    width: 372,
    height: 30,
    rx: 14,
    fill: "#16527b"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 57,
    r: 4,
    fill: "#ffd700"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 62,
    cy: 57,
    r: 4,
    fill: "#88d3ff"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 76,
    cy: 57,
    r: 4,
    fill: "#74d9b4"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 96,
    fill: "#ffd700",
    fontFamily: "Courier New, monospace",
    fontSize: 11
  }, "@RestController")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 116,
    fill: "#9dd9ff",
    fontFamily: "Courier New, monospace",
    fontSize: 11
  }, "@RequestMapping(\"/api/v1\")")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 136,
    fill: "#9dd9ff",
    fontFamily: "Courier New, monospace",
    fontSize: 11
  }, "class ThesisController {")), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 64,
    y: 156,
    fill: "#8be4c0",
    fontFamily: "Courier New, monospace",
    fontSize: 11
  }, "@GetMapping(\"/deliberation\")")), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 64,
    y: 176,
    fill: "#9dd9ff",
    fontFamily: "Courier New, monospace",
    fontSize: 11
  }, "ResponseEntity getDeliberation() {")), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 80,
    y: 196,
    fill: "#ffd700",
    fontFamily: "Courier New, monospace",
    fontSize: 11
  }, "return service.fetchByCandidate(id);")), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 64,
    y: 216,
    fill: "#9dd9ff",
    fontFamily: "Courier New, monospace",
    fontSize: 11
  }, "}")), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 236,
    fill: "#9dd9ff",
    fontFamily: "Courier New, monospace",
    fontSize: 11
  }, "}")), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 256,
    width: 340,
    height: 48,
    rx: 8,
    fill: "#0a2f48",
    stroke: "#2a729f"
  })), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    x: 56,
    y: 275,
    fill: "#8fd5ff",
    fontFamily: "Courier New, monospace",
    fontSize: 10
  }, "[Spring Boot] Started ThesisApiApplication in 4.216 seconds")), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    x: 56,
    y: 292,
    fill: "#ffe08b",
    fontFamily: "Courier New, monospace",
    fontSize: 10
  }, "GET /api/v1/deliberation 200 OK 32ms")), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 424,
    y: 54,
    width: 186,
    height: 132,
    rx: 12,
    fill: "url(#panel)",
    stroke: "#2f769f",
    strokeWidth: 1.4
  })), _text11 || (_text11 = /*#__PURE__*/React.createElement("text", {
    x: 442,
    y: 82,
    fill: "#ffdf78",
    fontFamily: "Arial, sans-serif",
    fontSize: 11,
    letterSpacing: 1
  }, "ENDPOINTS")), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 442,
    y: 94,
    width: 150,
    height: 20,
    rx: 10,
    fill: "#114867"
  })), _text12 || (_text12 = /*#__PURE__*/React.createElement("text", {
    x: 452,
    y: 108,
    fill: "#a9e0ff",
    fontFamily: "Courier New, monospace",
    fontSize: 10
  }, "GET /api/v1/deliberation")), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 442,
    y: 122,
    width: 136,
    height: 20,
    rx: 10,
    fill: "#134f74"
  })), _text13 || (_text13 = /*#__PURE__*/React.createElement("text", {
    x: 452,
    y: 136,
    fill: "#a9e0ff",
    fontFamily: "Courier New, monospace",
    fontSize: 10
  }, "POST /api/v1/report")), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 442,
    y: 150,
    width: 122,
    height: 20,
    rx: 10,
    fill: "#0f4060"
  })), _text14 || (_text14 = /*#__PURE__*/React.createElement("text", {
    x: 452,
    y: 164,
    fill: "#a9e0ff",
    fontFamily: "Courier New, monospace",
    fontSize: 10
  }, "PUT /api/v1/status")), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 424,
    y: 204,
    width: 186,
    height: 116,
    rx: 12,
    fill: "url(#panel)",
    stroke: "#2f769f",
    strokeWidth: 1.4
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 517,
    cy: 224,
    rx: 58,
    ry: 12,
    fill: "#1a628f"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 459,
    y: 224,
    width: 116,
    height: 58,
    fill: "#1a628f"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 517,
    cy: 282,
    rx: 58,
    ry: 12,
    fill: "#14527a"
  })), _text15 || (_text15 = /*#__PURE__*/React.createElement("text", {
    x: 517,
    y: 255,
    fill: "#fff0b3",
    fontFamily: "Arial, sans-serif",
    fontSize: 11,
    textAnchor: "middle",
    letterSpacing: 1
  }, "POSTGRESQL")), _text16 || (_text16 = /*#__PURE__*/React.createElement("text", {
    x: 517,
    y: 304,
    fill: "#a8ddff",
    fontFamily: "Courier New, monospace",
    fontSize: 10,
    textAnchor: "middle"
  }, "thesis_db / jury_results")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M402 120h22",
    stroke: "url(#line)",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M402 262h22",
    stroke: "url(#line)",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "414,112 426,120 414,128",
    fill: "#ffd700"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "414,254 426,262 414,270",
    fill: "#ffd700"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackend);
export default __webpack_public_path__ + "static/media/backend.e3822b41a701b2a9d3316b79bdbed8b8.svg";
export { ForwardRef as ReactComponent };